module.exports = __webpack_public_path__ + "img/99d328e.svg";